import React from 'react';

import { ConfluenceUpgradeFreePoolExperimentModalPostUpgrade } from '@atlassian/upgrade-free-pool-target-experiment';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';

import { ExperimentErrorBoundaryWrapper } from '../common/ErrorBoundaryWrapper.tsx';

export const UpgradeFreePoolExperimentModalPostUpgradeModalBaseComponent = () => {
	const { cloudId, edition } = useSessionData();

	// Audience is only eligible to see this experiment modal if they have upgraded to Confluence Standard edition
	if (!cloudId || !edition || edition !== ConfluenceEdition.STANDARD) {
		return null;
	}

	const confluenceStorageAdapter = {
		get: (key: string) => {
			return confluenceLocalStorageInstance.getItem(key);
		},
		set: (key: string, value: string) => {
			confluenceLocalStorageInstance.setItem(key, value);
		},
		removeItem: (key: string) => {
			confluenceLocalStorageInstance.removeItem(key);
		},
	};

	return (
		<ExperimentErrorBoundaryWrapper
			experimentKey="twcg-206_confluence_upgrade_permanent_free"
			source="UpgradeFreePoolExperimentModalPostUpgradeModalBaseComponent"
			cohort="variation" // Post-upgrade users are always in the variation cohort
			additionalAttributes={{
				cloudId,
				edition,
			}}
		>
			<ConfluenceUpgradeFreePoolExperimentModalPostUpgrade
				storageAdapter={confluenceStorageAdapter}
			/>
		</ExperimentErrorBoundaryWrapper>
	);
};
